document.addEventListener("DOMContentLoaded", () => {

    const cpInput = document.getElementById("cx-cp");
    const resultado = document.getElementById("cx-result");

    if (!cpInput || !resultado) return;

    // Configuración de zonas
    const zonas = {

        "01":[109,500],
        "02":[109,500],
        "07":[109,500],
        "14":[109,500],

        "03":[69,325],
        "08":[69,325],

        "04":[59,250],

        "05":[149,750],
        "10":[149,750],
        "16":[149,750],

        "06":[89,400],

        "09":[0,130]

    };

    function consultarCP(){

        const cp = cpInput.value.trim();

        resultado.innerHTML = "";

        if(cp.length < 5){
            return;
        }

        if(!/^\d{5}$/.test(cp)){
            resultado.innerHTML = "Ingresa un código postal válido.";
            return;
        }

        const prefijo = cp.substring(0,2);

        const zona = zonas[prefijo];

        if(!zona){

            resultado.innerHTML =
                "Actualmente no realizamos entregas en este código postal.";

            return;

        }

        const envio = zona[0];
        const minimo = zona[1];

        resultado.innerHTML = `
<div class="cx-shipping-card">

    <div class="cx-shipping-title">
        📍 Código Postal ${cp}
    </div>

    <div class="cx-shipping-item">
        <span>Costo de envío</span>
        <strong>${envio === 0 ? "GRATIS" : "$" + envio.toFixed(2)}</strong>
    </div>

    <div class="cx-shipping-item">
        <span>Compra mínima</span>
        <strong>$${minimo}</strong>
    </div>

</div>
`;

    }

    cpInput.addEventListener("input", () => {

        if(cpInput.value.length === 5){
            consultarCP();
        }

    });

    cpInput.addEventListener("change", consultarCP);

});